import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class VisionStepPerimeterScenario extends BasicScenario {
manageKeys: boolean | null;
}

